import { render } from "./SectionSelector.vue?vue&type=template&id=9fe33c94&scoped=true&ts=true"
import script from "./SectionSelector.vue?vue&type=script&lang=ts"
export * from "./SectionSelector.vue?vue&type=script&lang=ts"

import "./SectionSelector.vue?vue&type=style&index=0&id=9fe33c94&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe33c94"]])

export default __exports__